import * as React from 'react';
import * as w from '@packages/systems/wfdl';
import * as wast from '@packages/systems/wfdl-ast';

import RequestInput from './RequestInput';

const tooltipText = 'Select the type of HTTP request you want to make.';

const textInputType = w.withMeta(
  {
    multiLine: true,
    placeholder: 'Add body content...',
  },
  w.withSystem({label: 'Body', isFullWidth: true, private: true}, wast.TText)
);

const NonbindedEmptyRecord = w.withSystem(
  {bindUIVariant: 'custom', private: true},
  wast.TEmptyRecord
);

const MethodType = w.withMeta(
  {variant: 'menu'},
  wast.TUnion({
    GET: NonbindedEmptyRecord,
    POST: textInputType,
    PUT: textInputType,
    PATCH: textInputType,
    DELETE: NonbindedEmptyRecord,
  })
);

export const RequestMethodType = w.TypeImplementation.Alias({
  type: w.withSystem(
    {isFullWidth: true, labelVariant: 'hidden', bindUIVariant: 'custom'},
    MethodType
  ),
  render: function RenderRequestMethod({expr, dispatch}) {
    return (
      <RequestInput
        label="Request method"
        tooltipText={tooltipText}
        expr={expr}
        dispatch={dispatch}
        required={false}
      />
    );
  },
});
